<template>
  <div class="tabs-component">
    <button
      type="button"
      :class="`row-format align-center ${titleClass()}`"
      ref="moduleTitle"
      v-if="title && title.label"
      :disabled="title.uri === currentPath"
      @click="goTo(title)"
    >
      <div><span>{{$t(title.label)}}</span></div>
      <div v-if="parentValue" class="row-format align-center">
        <portal-icon name="chevron-right" :size="12" class="mx-1"></portal-icon>
        <div @click.stop="$router.push(parentValue.route)">{{$t(parentValue.parent)}}</div>
      </div>
      <div v-if="navDetailValue" class="row-format align-center">
        <portal-icon name="chevron-right" :size="12" class="mx-1"></portal-icon>
        <div class="tab-item selected" style="cursor: default!important;" @click.stop>{{$t(navDetailValue)}}</div>
      </div>
    </button>
    <div class="tabs-wrapper" v-if="visibleTabs.length || menuTabs.length" ref="visibleTabs">
      <button type="button" :class="tabClass(tab)" v-for="tab in visibleTabs" :key="tab.uri" @click="goTo(tab)">
        {{ $t(tab.label) }}
      </button>
      <div class="menu-wrapper" v-if="menuTabs.length">
        <v-menu
            ref="menuTabs"
            v-model="menuTabsOpen"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <button type="button" :class="menuActivatorClass" v-on="on" ref="menuTabsActivator">
              {{ $t(moreVerb) }}
              <portal-icon v-if="menuTabsOpen" class="ml-1" :size="14" name="chevron-up"></portal-icon>
              <portal-icon v-else :size="14" class="ml-1" name="chevron-down"></portal-icon>
            </button>
          </template>
          <v-list>
            <v-list-item v-for="tab in menuTabs" :key="tab.uri" @click="goTo(tab)">
              {{ $t(tab.label) }}
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'TopNav',
  props: {
    currentPath: {type: String, required: true },
    tabConfig: { type: Object, required: true },
  },
  emits: ['set-page'],
  components: {},
  data() {
    return {
      availableWidth: 0,
      visibleTabs: [],
      menuTabs: [],
      title: null,
      menuTabsOpen: false,
      windowWidth: window.innerWidth,
    };
  },

  mounted() {
    this.resizeObserver = new ResizeObserver(() => this.onResize());
    this.resizeObserver.observe(this.$el);
  },


  beforeDestroy() {
    this.resizeObserver.disconnect();
  },

  methods: {
    goTo(tab) {
      if (this.currentPath === tab.uri) return;
      this.$router.push(tab.uri);
    },

    tabClass(tab) {
      // console.log(page);
      let css = ['tab-item'];
      if (tab.uri === this.currentPath) {
        css.push('selected');
      }
      return css.join(' ');
    },

    titleClass() {
      let css = ['module-title'];
      if (this.title.uri && this.title.uri !== this.currentPath) {
        css.push('pointer');
      }
      return css.join(' ');
    },

    onResize() {
      this.menuTabsOpen = false;
      this.windowWidth = window.innerWidth;
      if (!this.$el || this.availableWidth === this.$el.clientWidth) return;
      this.availableWidth = this.$el.clientWidth;
      this.setTabs();
    },

    async setTabs() {
      // Init arrays
      this.visibleTabs.splice(0, this.visibleTabs.length);
      this.menuTabs.splice(0, this.menuTabs.length);

      if (!this.tabs.length) return;


      if(!this.$store.getters.getFeatures.summaryFinancialsEnabled){
        let ix = this.tabs.findIndex(t => t.uri === '/invoices?v=reports');
        if(ix > -1){
          this.tabs.splice(ix,1);
        }
      }

      let i = 0;
      while (i < this.tabs.length) {
        let totalTabWidth;

        // Add page to tabs
        this.visibleTabs.push(this.tabs[i]);

        // Wait for DOM to update then get the total width used
        await this.$nextTick(()=> {
          totalTabWidth = this.totalTabWidth();
        });
        //console.log('totalTabWidth', totalTabWidth);

        if (!this.widthOk(i, totalTabWidth)) {
          this.visibleTabs.pop();
          break;
        }
        i++;
      }

      while (i < this.tabs.length) {
        this.menuTabs.push(this.tabs[i]);
        i++;
      }
    },

    widthOk(i, totalTabWidth) {
      if (i === this.tabs.length - 1) { // if last tab, don't include "more" button
        return totalTabWidth <= this.availableWidth;
      }
      return totalTabWidth <= this.availableWidth - this.widthOfMoreButton();
    },

    widthOfMoreButton() {
      let tabWidth = 50 + 24 + 24; // More link (approx 50px) + gaps
      // tabWidth += 40; // Shim it a bit for good measure and beauty
      return tabWidth;
    },

    totalTabWidth() {
      let tabWidth = 0;

      if (this.$refs.moduleTitle) {
        //console.log('titleWidth', this.$refs.moduleTitle.clientWidth);
        tabWidth = this.$refs.moduleTitle.clientWidth;
        tabWidth += 24; // gap
      } else {
        console.log('moduleTitle is NOT defined');
      }

      let tabs = [];
      if (this.$refs.visibleTabs) {
        tabs = Array.from(this.$refs.visibleTabs.children);
      }

      for (let v of tabs) {
        //console.log(v.innerHTML, v.clientWidth);
        tabWidth += v.clientWidth;
        tabWidth += 24; // gap
      }
      //console.log('tabWidth', tabWidth);
      return tabWidth;
    },

  },

  watch: {
    tabs: {
      deep: true,
      handler(){
        setTimeout(() => this.setTabs(),100);
      }
    },

    tabConfig: {
      immediate: true,
      deep: true,
      handler(config) {
        this.tabs.splice(0, this.tabs.length);
        this.tabs.push(...config.tabs);
        this.title = config.title;
        this.setTabs();
      }
    },
  },

  computed: {
    tabs: function(){
      return this.$store.state.tabs;
    },

    navDetailValue: function(){
      if(this.title && this.title.navDetailKey){
        let value = this.$store.state.navDetailKeys.find(k => k.key === this.title.navDetailKey);
        if(value){
          return value.value;
        }
      }

      return null;
    },

    parentValue: function(){
      if(this.title && this.title.navDetailKey){
        let value = this.$store.state.navDetailKeys.find(k => k.key === this.title.navDetailKey);
        if(value && value.parent){
          return {
            parent: value.parent,
            route: value.parentRoute
          }
        }
      }

      return null;
    },

    moreVerb() {
      if (this.visibleTabs.length < this.tabs.length) {
        let tab = this.menuTabs.find((t) => t.uri === this.currentPath);
        if (tab) {
          return tab.label;
        }
      }
      return this.$t('global.more');
    },
    menuActivatorClass() {
      let css = ['tab-item', 'row-format'];
      let idx = this.menuTabs.findIndex((t) => t.uri === this.currentPath);
      if (idx > -1) {
        css.push('selected');
      }
      return css.join(' ');
    }
  },
};
</script>

<style lang="scss">
.tabs-component {
  min-height: 48px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  overflow: hidden;

  .module-title {
    min-height: 36px;
    flex: 0 0 auto;
    border: 0;
    background: transparent;
    font-size: 14px;
    font-weight: 650;
    color: var(--portal-text);
    padding: 0;

    &:focus-visible {
      outline: 2px solid var(--v-primary-base);
      outline-offset: 2px;
      border-radius: var(--brand-button-radius, 6px);
    }
  }
  .tabs-wrapper {
    min-width: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
  }

  .tab-item {
    min-height: 34px;
    padding: 0 12px;
    border: 0;
    border-radius: var(--brand-button-radius, 9px);
    background: transparent;
    white-space: nowrap;
    color: var(--portal-muted);
    font-family: var(--brand-button-family, var(--primary-font)), sans-serif;
    font-size: var(--brand-button-size, 14px);
    font-weight: var(--brand-button-weight, 500);
    letter-spacing: var(--brand-button-letterSpacing, normal);
    display: flex;
    align-items: center;

    &:not(.selected) {
      cursor: pointer;
      &:hover {
        background: var(--v-gray_20-base);
        color: var(--portal-text);
      }
    }

    &.selected {
      color: var(--v-primary-base);
      background: var(--v-blue_5-base);
      box-shadow: inset 0 0 0 1px var(--v-primary-base);
    }

    &:focus-visible {
      outline: 2px solid var(--v-primary-base);
      outline-offset: 1px;
    }
  }
}

.portal-brand-kit .tabs-component .tab-item.selected {
  color: var(--brand-button-secondaryText);
  background: var(--brand-button-secondaryBackground);
  box-shadow: inset 0 0 0 var(--brand-button-borderWidth) var(--brand-button-secondaryBorder);
}

.portal-brand-kit.brand-secondary-text .tabs-component .tab-item.selected {
  box-shadow: none;
}
</style>
